import React, { useState, useEffect } from 'react';
import { makeRequestAuth } from '../../_config/api';
import { showErrorToast } from '../../utils/toastUtils';
import { ToastContainer } from 'react-toastify';
import ManualAssignModal from './ManualAssignModal';

const IconPlus = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><path d="M12 5v14M5 12h14"></path></svg>;
const IconEdit = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>;
const IconTrash = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>;
const IconClock = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>;
const IconList = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>;
const IconInfo = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>;
const IconTimes = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>;
const IconSave = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1em" width="1em"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>;
const IconView = () => <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="1.1em" width="1.1em"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>;

const SubscriptionManager = () => {
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false); 
    const [services, setServices] = useState([]);
    const [serviceCategories, setServiceCategories] = useState([]);

    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [viewPlan, setViewPlan] = useState(null);
    const [confirmModal, setConfirmModal] = useState({
        isOpen: false,
        type: '',
        title: '',
        message: '',
        onConfirm: null
    });
    const [loading, setLoading] = useState(false);
    const [plans, setPlans] = useState([]);

    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentPlan, setCurrentPlan] = useState({
        name: '',
        durationDays: '',
        price: '',
        discountPrice: '',
        description: '',
        points: [],
        serviceCategory: ""
    });

    // Handle Modal Open
    const openModal = (plan = null) => {
        if (plan) {
            setCurrentPlan({ ...plan });
            setEditMode(true);
        } else {
            setCurrentPlan({
                name: '',
                durationDays: '',
                price: '',
                discountPrice: '',
                description: '',
                points: []
            });
            setEditMode(false);
        }
        setIsModalOpen(true);
    };

    const fetchPlans = async () => {
        try {
            setLoading(true);

            const res = await makeRequestAuth('post', "/admin/subscriptionPlanList");

            if (res.error === false) {
                setPlans(res.data.plans || []);
            } else {
                showErrorToast(res.message);
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchServiceCategories = async () => {
        try {
            const res = await makeRequestAuth('post', "/admin/getListServiceCategory");

            if (!res.error) {
                setServiceCategories(res.data?.list || []);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        fetchPlans();
        fetchServiceCategories();
    }, []);

    // Handle Point Changes
    const addPoint = () => {
        setCurrentPlan({
            ...currentPlan,
            points: [...currentPlan.points, { name: '', type: 'count', value: '', limit: 0 }]
        });
    };

    const removePoint = (index) => {
        const newPoints = currentPlan.points.filter((_, i) => i !== index);
        setCurrentPlan({ ...currentPlan, points: newPoints });
    };

    const updatePoint = (index, field, value) => {
        const newPoints = [...currentPlan.points];
        newPoints[index][field] = value;
        setCurrentPlan({ ...currentPlan, points: newPoints });
    };

    const handleSave = async () => {
        try {
            for (let p of currentPlan.points) {

                if (!p.name) return showErrorToast("Point name required");

                if (["count", "discount"].includes(p.type) && !p.serviceCategory) {
                    return showErrorToast("Service category required");
                }

                if (p.type === "count" && (!p.limit || p.limit <= 0)) {
                    return showErrorToast("Limit required for count");
                }

                if (p.type === "discount") {
                    if (!p.value || p.value > 100) {
                        return showErrorToast("Discount must be 0-100%");
                    }
                }

                if (p.type === "boolean" && !p.value) {
                    return showErrorToast("Select Yes/No");
                }

                if (p.type === "text" && !p.value) {
                    return showErrorToast("Text value required");
                }
            }

            const payload = {
                ...(editMode && { id: currentPlan._id }),

                name: currentPlan.name,
                durationDays: Number(currentPlan.durationDays),
                price: Number(currentPlan.price),
                discountPrice: Number(currentPlan.discountPrice) || 0,
                description: currentPlan.description || "",

                points: currentPlan.points.map(p => {
                    let base = {
                        name: p.name,
                        type: p.type
                    };

                    if (["count", "discount"].includes(p.type)) {
                        base.serviceCategory = p.serviceCategory;
                    }

                    if (p.type === "count") {
                        base.limit = Number(p.limit);
                    }

                    if (p.type === "discount") {
                        base.value = p.value;
                        base.limit = Number(p.limit);
                    }

                    if (p.type === "boolean" || p.type === "text") {
                        base.value = p.value;
                    }

                    return base;
                })
            };

            let res;
            if (editMode) {
                res = await makeRequestAuth('post', "/admin/editSubscription", payload);
            } else {
                res = await makeRequestAuth('post', "/admin/subscriptionPlanCreate", payload);
            }


            if (!res.error) {
                await fetchPlans();
                setIsModalOpen(false);
            } else {
                showErrorToast(res.message);
            }

        } catch (error) {
            console.log(error);
            showErrorToast(error.message || "Something went wrong");
        }
    };

    const handleStatusToggle = async (planId) => {
        try {
            const res = await makeRequestAuth('post', "/admin/toggleSubscriptionPlan", {
                id: planId
            });
            if (!res.error) {
                fetchPlans();
            }
        } catch (error) {
            showErrorToast(error.message || "Failed to update status");
        }
    };

    const handleDelete = async (id) => {
        try {
            const res = await makeRequestAuth('post', "/admin/deleteSubscription", { id });
            if (!res.error) {
                setPlans(plans.filter(p => p._id !== id));
            } else {
                showErrorToast(res.message);
            }
        } catch (error) {
            showErrorToast(error.message || "Error deleting plan");
        }
    };

    return (
        <div className="p-4 md:p-8 bg-[#F8F9FD] min-h-screen font-sans text-[#2D3748] relative">
            <ToastContainer />
            {/* --- HEADER --- */}
            <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
                <div>
                    <h1 className="text-3xl font-extrabold text-[#1A202C]">
                        Subscription <span className="text-[#24ADD7]">Plans</span>
                    </h1>
                    <p className="text-gray-500 text-sm mt-1 flex items-center gap-2">
                        <IconInfo /> Configure your pricing and plan benefits.
                    </p>
                </div>
                              <div className="flex gap-4">
                     <button 
                         onClick={() => setIsAssignModalOpen(true)} 
                         className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-2xl font-bold flex items-center gap-2 transition-all shadow-lg shadow-green-200"
                     >
                         Assign Plan Manually
                     </button>
                     <button
                         onClick={() => openModal()}
                         className="bg-[#24ADD7] hover:bg-[#0d5f78] text-white px-6 py-3 rounded-2xl font-bold flex items-center gap-2 transition-all shadow-lg shadow-blue-200"
                     >
                         <IconPlus /> Create New Plan
                     </button>
                </div>

            </div>

            {loading && (
                <div className="p-6 text-center text-gray-400 font-bold">
                    Loading plans...
                </div>
            )}

            {/* --- TABLE --- */}
            <div className="bg-white rounded-[32px] shadow-xl shadow-gray-100/50 border border-gray-50 overflow-hidden">
                <div className="p-6 border-b border-gray-50 bg-gray-50/30 flex justify-between items-center">
                    <h3 className="font-bold text-lg flex items-center gap-2">
                        <span className="text-[#24ADD7]"><IconList /></span> Plan Inventory
                    </h3>
                </div>

                <div className="overflow-x-auto bg-white shadow-sm border-y border-gray-100"> {/* Border radius removed from container */}
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="text-left bg-gray-50/50 border-b border-gray-100 text-gray-400 text-[10px] font-bold uppercase tracking-widest">
                                <th className="px-6 py-4">Plan Name</th>
                                <th className="px-6 py-4">Terms</th>
                                <th className="px-6 py-4">Pricing</th>
                                <th className="px-6 py-4">GST</th>
                                <th className="px-6 py-4">Features</th>
                                <th className="px-6 py-4 text-center">Status</th>
                                <th className="px-6 py-4">Dates</th>
                                <th className="px-6 py-4 text-right">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {plans.map((plan) => (
                                <tr key={plan._id} className="hover:bg-gray-50/30 transition-colors">

                                    {/* NAME & DESCRIPTION */}
                                    <td className="px-6 py-5">
                                        <div className="font-bold text-[#1A202C] text-sm">{plan.name}</div>
                                        <div className="text-[11px] text-gray-400 truncate max-w-[150px]">
                                            {plan.description || "No description"}
                                        </div>
                                    </td>

                                    {/* DURATION */}
                                    <td className="px-6 py-5 text-sm font-medium text-gray-600">
                                        {plan.durationDays} Days
                                    </td>

                                    {/* PRICE */}
                                    <td className="px-6 py-5">
                                        <div className="font-bold text-gray-900 text-sm">₹{plan.discountPrice || plan.price}</div>
                                        {plan.discountPrice && (
                                            <div className="text-[10px] line-through text-gray-300">
                                                ₹{plan.price}
                                            </div>
                                        )}
                                    </td>

                                    {/* GST */}
                                    <td className="px-6 py-5 text-sm text-gray-500 font-semibold">
                                        {plan.gst || 0}%
                                    </td>

                                    {/* FEATURES */}
                                    <td className="px-6 py-5">
                                        {plan.points.length > 0 ? (
                                            <div className="flex flex-wrap gap-1">
                                                {plan.points.slice(0, 2).map((p, i) => (
                                                    <span key={i} className="text-[9px] bg-indigo-50 text-indigo-500 px-2 py-0.5 font-bold uppercase tracking-tighter">
                                                        {p.name}
                                                    </span>
                                                ))}
                                                {plan.points.length > 2 && (
                                                    <span className="text-[9px] text-gray-400 font-bold">+{plan.points.length - 2} more</span>
                                                )}
                                            </div>
                                        ) : (
                                            <span className="text-[10px] text-gray-300 italic">None</span>
                                        )}
                                    </td>

                                    {/* STATUS */}
                                    <td className="px-6 py-5 text-center">
                                        <button
                                            onClick={() => setConfirmModal({
                                                isOpen: true,
                                                type: 'status',
                                                title: 'Change Status?',
                                                message: `Switch status for "${plan.name}"?`,
                                                onConfirm: () => handleStatusToggle(plan._id)
                                            })}
                                            className={`inline-flex items-center px-3 py-1 text-[10px] font-black tracking-tighter transition-all ${plan.isActive
                                                ? 'text-green-600 bg-green-50 border border-green-100'
                                                : 'text-gray-400 bg-gray-50 border border-gray-100'
                                                }`}
                                        >
                                            {plan.isActive ? "ACTIVE" : "INACTIVE"}
                                        </button>
                                    </td>

                                    {/* TIMESTAMPS */}
                                    <td className="px-6 py-5">
                                        <div className="text-[10px] text-gray-400 whitespace-nowrap">
                                            <span className="font-bold">IN:</span> {new Date(plan.createdAt).toLocaleDateString()}
                                        </div>
                                        <div className="text-[10px] text-gray-400 whitespace-nowrap">
                                            <span className="font-bold">UP:</span> {new Date(plan.updatedAt).toLocaleDateString()}
                                        </div>
                                    </td>

                                    {/* ACTION */}
                                    <td className="px-6 py-5 text-right">
                                        <div className="flex gap-1 justify-end">
                                            <button
                                                onClick={() => openModal(plan)}
                                                className="p-2 text-indigo-400 hover:text-indigo-600 hover:bg-indigo-50 transition-all"
                                            >
                                                <IconEdit />
                                            </button>
                                            <button
                                                onClick={() => setConfirmModal({
                                                    isOpen: true,
                                                    type: 'delete',
                                                    title: 'Delete?',
                                                    message: 'This cannot be undone.',
                                                    onConfirm: () => handleDelete(plan._id)
                                                })}
                                                className="p-2 text-red-300 hover:text-red-500 hover:bg-red-50 transition-all"
                                            >
                                                <IconTrash />
                                            </button>
                                            <button
                                                onClick={() => setViewPlan(plan)}
                                                className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-all"
                                                title="View Details"
                                            >
                                                <IconView />
                                            </button>
                                        </div>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* --- CUSTOM WARNING MODAL --- */}
            {confirmModal.isOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
                    <div className="bg-white w-full max-w-sm rounded-[32px] p-8 shadow-2xl scale-in-center">
                        <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto ${confirmModal.type === 'delete' ? 'bg-red-50 text-red-500' : 'bg-orange-50 text-orange-500'}`}>
                            {confirmModal.type === 'delete' ? <IconTrash /> : <IconInfo />}
                        </div>

                        <h3 className="text-xl font-black text-center text-[#1A202C] mb-2">
                            {confirmModal.title}
                        </h3>

                        <p className="text-gray-500 text-center text-sm mb-8">
                            {confirmModal.message}
                        </p>

                        <div className="flex gap-3">
                            <button
                                onClick={() => setConfirmModal({ ...confirmModal, isOpen: false })}
                                className="flex-1 py-3 font-bold text-gray-400 hover:bg-gray-50 rounded-2xl transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    confirmModal.onConfirm();
                                    setConfirmModal({ ...confirmModal, isOpen: false });
                                }}
                                className={`flex-1 py-3 font-bold text-white rounded-2xl shadow-lg transition ${confirmModal.type === 'delete' ? 'bg-red-500 hover:bg-red-600' : 'bg-[#24ADD7] hover:bg-[#E85A2A]'}`}
                            >
                                Yes, Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {viewPlan && (
                <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-md p-4">
                    <div className="bg-white w-full max-w-2xl rounded-[32px] shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">

                        {/* Header section with solid background */}
                        <div className="px-8 py-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
                            <div>
                                <h2 className="text-xl font-black text-[#1A202C] tracking-tight">
                                    Plan <span className="text-[#24ADD7]">Overview</span>
                                </h2>
                                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest mt-0.5">ID: {viewPlan._id}</p>
                            </div>
                            <button
                                onClick={() => setViewPlan(null)}
                                className="p-2.5 bg-white hover:bg-red-50 hover:text-red-500 text-gray-400 rounded-xl transition-all shadow-sm border border-gray-100"
                            >
                                <IconTimes />
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="p-8 max-h-[75vh] overflow-y-auto custom-scrollbar">

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                                {/* LEFT COLUMN: Basic & Pricing */}
                                <div className="space-y-6">
                                    <section>
                                        <label className="text-[10px] font-black text-[#24ADD7] uppercase tracking-widest block mb-2">Core details</label>
                                        <h3 className="text-2xl font-black text-[#1A202C] leading-tight">{viewPlan.name}</h3>
                                        <p className="text-sm text-gray-500 mt-2 leading-relaxed">{viewPlan.description || "No description provided for this plan."}</p>
                                    </section>

                                    <section className="bg-gray-50 rounded-3xl p-6 border border-gray-100">
                                        <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-4">Pricing Strategy</label>
                                        <div className="flex items-end gap-3 mb-1">
                                            <span className="text-3xl font-black text-[#1A202C]">₹{viewPlan.discountPrice}</span>
                                            <span className="text-sm text-gray-400 line-through mb-1.5">₹{viewPlan.price}</span>
                                            <span className="ml-auto bg-blue-100 text-blue-600 text-[10px] font-bold px-2 py-1 rounded-lg">GST {viewPlan.gst || 0}%</span>
                                        </div>
                                        <p className="text-[11px] text-gray-400 font-medium italic">* Final price includes all applicable taxes.</p>
                                    </section>
                                </div>

                                {/* RIGHT COLUMN: Duration & Metadata */}
                                <div className="space-y-6">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="p-4 border border-gray-100 rounded-2xl">
                                            <label className="text-[9px] font-black text-gray-400 uppercase block mb-1">Validity</label>
                                            <div className="font-bold text-gray-700 flex items-center gap-2">
                                                <IconClock /> {viewPlan.durationDays} Days
                                            </div>
                                        </div>
                                        <div className="p-4 border border-gray-100 rounded-2xl">
                                            <label className="text-[9px] font-black text-gray-400 uppercase block mb-1">Current Status</label>
                                            <div className={`inline-flex items-center text-[11px] font-black ${viewPlan.isActive ? "text-green-500" : "text-gray-300"}`}>
                                                {viewPlan.isActive ? "● ACTIVE" : "● INACTIVE"}
                                            </div>
                                        </div>
                                    </div>

                                    <section>
                                        <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3">Plan Features</label>
                                        <div className="space-y-2">
                                            {viewPlan.points.length > 0 ? (
                                                viewPlan.points.map((p, i) => (
                                                    <div key={i} className="flex justify-between items-center p-3 bg-white border border-gray-50 rounded-xl shadow-sm hover:border-orange-100 transition-colors">
                                                        <span className="text-sm font-bold text-gray-700">{p.name}</span>
                                                        <span className="text-[10px] font-black bg-gray-100 px-2 py-1 rounded-md text-gray-500">
                                                            {p.type === "count" ? `LIMIT: ${p.limit}` : p.value}
                                                        </span>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="text-center py-4 border-2 border-dashed border-gray-100 rounded-2xl text-gray-400 text-xs italic">No features listed</div>
                                            )}
                                        </div>
                                    </section>
                                </div>
                            </div>

                            {/* Footer Timestamps */}
                            <div className="mt-10 pt-6 border-t border-gray-100 flex flex-col md:flex-row justify-between gap-4">
                                <div className="flex items-center gap-2 text-gray-400">
                                    <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center"><IconPlus /></div>
                                    <div className="text-[10px]">
                                        <p className="font-bold uppercase leading-none">Created At</p>
                                        <p className="mt-0.5">{new Date(viewPlan.createdAt).toLocaleString()}</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 text-gray-400">
                                    <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center"><IconEdit /></div>
                                    <div className="text-[10px]">
                                        <p className="font-bold uppercase leading-none">Last Updated</p>
                                        <p className="mt-0.5">{new Date(viewPlan.updatedAt).toLocaleString()}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Final Action Button */}
                        <div className="p-6 bg-gray-50 text-right">
                            <button
                                onClick={() => setViewPlan(null)}
                                className="px-8 py-3 bg-[#1A202C] text-white text-xs font-black rounded-2xl hover:bg-black transition-all active:scale-95"
                            >
                                CLOSE PREVIEW
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
                    <div className="bg-white w-full max-w-4xl rounded-[32px] shadow-2xl overflow-hidden">
                        {/* Modal Header */}
                        <div className="p-6 border-b flex justify-between items-center bg-gray-50/50">
                            <h2 className="text-2xl font-black text-[#1A202C]">
                                {editMode ? 'Update' : 'Create'} <span className="text-[#24ADD7]">Plan</span>
                            </h2>
                            <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-gray-200 rounded-full transition text-gray-400">
                                <IconTimes />
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="p-8 max-h-[70vh] overflow-y-auto">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                                <div className="space-y-2">
                                    <label className="text-xs font-bold text-gray-400 uppercase tracking-wider">Plan Name</label>
                                    <input
                                        type="text"
                                        value={currentPlan.name}
                                        onChange={(e) => setCurrentPlan({ ...currentPlan, name: e.target.value })}
                                        className="w-full p-3 border-2 border-gray-100 rounded-xl focus:border-[#24ADD7] outline-none transition"
                                        placeholder="e.g. Gold Monthly"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="text-xs font-bold text-gray-400 uppercase tracking-wider">Duration (Days)</label>
                                    <input
                                        type="number"
                                        value={currentPlan.durationDays}
                                        onChange={(e) => setCurrentPlan({ ...currentPlan, durationDays: e.target.value })}
                                        className="w-full p-3 border-2 border-gray-100 rounded-xl focus:border-[#24ADD7] outline-none transition"
                                        placeholder="30"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="text-xs font-bold text-gray-400 uppercase tracking-wider">Original Price</label>
                                    <input
                                        type="number"
                                        value={currentPlan.price}
                                        onChange={(e) => setCurrentPlan({ ...currentPlan, price: e.target.value })}
                                        className="w-full p-3 border-2 border-gray-100 rounded-xl focus:border-[#24ADD7] outline-none transition"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="text-xs font-bold text-gray-400 uppercase tracking-wider">Discount Price</label>
                                    <input
                                        type="number"
                                        value={currentPlan.discountPrice}
                                        onChange={(e) => setCurrentPlan({ ...currentPlan, discountPrice: e.target.value })}
                                        className="w-full p-3 border-2 border-gray-100 rounded-xl focus:border-[#24ADD7] outline-none transition"
                                    />
                                </div>
                                <div className="space-y-2 md:col-span-2">
                                    <label className="text-xs font-bold text-gray-400 uppercase tracking-wider">Description</label>
                                    <textarea
                                        value={currentPlan.description}
                                        onChange={(e) => setCurrentPlan({ ...currentPlan, description: e.target.value })}
                                        className="w-full p-3 border-2 border-gray-100 rounded-xl focus:border-[#24ADD7] outline-none transition"
                                        rows="2"
                                    />
                                </div>
                            </div>

                            {/* Points Section */}
                            <div className="bg-gray-50 p-6 rounded-[24px] border-2 border-dashed border-gray-200">
                                <div className="flex justify-between items-center mb-4">
                                    <h4 className="text-sm font-black text-gray-500 uppercase tracking-widest flex items-center gap-2">
                                        <span className="text-[#24ADD7]"><IconList /></span> Plan Features (Points)
                                    </h4>
                                    <button
                                        onClick={addPoint}
                                        className="text-xs bg-[#1A202C] text-white px-4 py-2 rounded-lg font-bold hover:bg-black transition"
                                    >
                                        + Add Point
                                    </button>
                                </div>

                                <div className="space-y-3">
                                    {currentPlan.points.map((point, index) => (
                                        <div key={index} className="grid grid-cols-12 gap-3 items-center bg-white p-3 rounded-xl shadow-sm border border-gray-100">
                                            <div className="col-span-5">
                                                <input
                                                    type="text"
                                                    placeholder="Point Name"
                                                    value={point.name}
                                                    onChange={(e) => updatePoint(index, 'name', e.target.value)}
                                                    className="w-full text-xs p-2 border rounded-lg outline-none"
                                                />
                                            </div>
                                            <div className="col-span-3">
                                                <select
                                                    value={point.type}
                                                    onChange={(e) => updatePoint(index, 'type', e.target.value)}
                                                    className="w-full text-xs p-2 border rounded-lg outline-none"
                                                >
                                                    <option value="count">Count</option>
                                                    <option value="discount">Discount</option>  // 🔥 ADD THIS
                                                    <option value="boolean">Boolean</option>
                                                    <option value="text">Text</option>
                                                </select>
                                            </div>
                                            <div className="col-span-3">

                                                {point.type === "count" && (
                                                    <input
                                                        type="number"
                                                        placeholder="Limit"
                                                        value={point.limit}
                                                        onChange={(e) => updatePoint(index, 'limit', e.target.value)}
                                                        className="w-full text-xs p-2 border rounded-lg outline-none"
                                                    />
                                                )}

                                                {point.type === "discount" && (
                                                    <div className="flex gap-1">
                                                        <input
                                                            type="number"
                                                            placeholder="%"
                                                            value={point.value}
                                                            onChange={(e) => updatePoint(index, 'value', e.target.value)}
                                                            className="w-full text-xs p-2 border rounded-lg outline-none"
                                                        />
                                                        <input
                                                            type="number"
                                                            placeholder="Limit"
                                                            value={point.limit}
                                                            onChange={(e) => updatePoint(index, 'limit', e.target.value)}
                                                            className="w-full text-xs p-2 border rounded-lg outline-none"
                                                        />
                                                    </div>
                                                )}

                                                {point.type === "boolean" && (
                                                    <select
                                                        value={point.value}
                                                        onChange={(e) => updatePoint(index, 'value', e.target.value)}
                                                        className="w-full text-xs p-2 border rounded-lg"
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="true">Yes</option>
                                                        <option value="false">No</option>
                                                    </select>
                                                )}

                                                {point.type === "text" && (
                                                    <input
                                                        type="text"
                                                        placeholder="Text value"
                                                        value={point.value}
                                                        onChange={(e) => updatePoint(index, 'value', e.target.value)}
                                                        className="w-full text-xs p-2 border rounded-lg outline-none"
                                                    />
                                                )}

                                                {["count", "discount"].includes(point.type) && (
                                                    <div className="col-span-3">
                                                        <select
                                                            value={point.serviceCategory || ""}
                                                            onChange={(e) => updatePoint(index, 'serviceCategory', e.target.value)}
                                                            className="w-full text-xs p-2 border rounded-lg"
                                                        >
                                                            <option value="">Select Category</option>
                                                            {serviceCategories.map((cat) => (
                                                                <option key={cat._id} value={cat._id}>
                                                                    {cat.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}
                                            </div>


                                            <div className="col-span-1 text-center text-red-400 cursor-pointer hover:text-red-600" onClick={() => removePoint(index)}>
                                                <IconTrash />
                                            </div>
                                        </div>
                                    ))}
                                </div>


                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="p-6 bg-gray-50 flex justify-end gap-4">
                            <button onClick={() => setIsModalOpen(false)} className="px-6 py-3 font-bold text-gray-400 hover:text-gray-600 transition">
                                Cancel
                            </button>
                            <button
                                onClick={handleSave}
                                className="px-8 py-3 bg-[#24ADD7] text-white font-bold rounded-2xl shadow-lg shadow-orange-100 flex items-center gap-2 hover:bg-[#E85A2A] transition"
                            >
                                <IconSave /> {editMode ? 'Update Plan' : 'Save Plan'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
                        {/* MANUAL ASSIGN MODAL */}
            <ManualAssignModal 
                isOpen={isAssignModalOpen} 
                onClose={() => setIsAssignModalOpen(false)} 
                allPlans={plans} 
            /> 

        </div>
    );
};

export default SubscriptionManager;